import { render } from "./OrdersReporting.vue?vue&type=template&id=04caed84&scoped=true"
import script from "./OrdersReporting.vue?vue&type=script&lang=js"
export * from "./OrdersReporting.vue?vue&type=script&lang=js"

import "./OrdersReporting.vue?vue&type=style&index=0&id=04caed84&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04caed84"]])

export default __exports__